// apps/web/src/hooks/use-logout.ts
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import { useAuthStore } from '@/stores/auth-store';
import { authApi } from '@/lib/api/auth';

export function useLogout() {
  const navigate = useNavigate();
  const clear = useAuthStore((state) => state.clear);

  const logoutMutation = useMutation({
    mutationFn: authApi.logout,
    onSuccess: () => {
      // Clear local state regardless of API result
      clear();
      // Redirect to login page
      navigate('/login');
    },
    onError: () => {
      // Even if API fails, clear local state and redirect
      clear();
      navigate('/login');
    },
  });

  const logout = () => {
    logoutMutation.mutate();
  };

  return {
    logout,
    isPending: logoutMutation.isPending,
  };
}
